/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Hero_AnywhereInputs */

const en_auth_hero_anywhere = /** @type {(inputs: Auth_Hero_AnywhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anywhere`)
};

const es_auth_hero_anywhere = /** @type {(inputs: Auth_Hero_AnywhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`donde quieras`)
};

/**
* | output |
* | --- |
* | "anywhere" |
*
* @param {Auth_Hero_AnywhereInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_hero_anywhere = /** @type {((inputs?: Auth_Hero_AnywhereInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Hero_AnywhereInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_hero_anywhere(inputs)
	return en_auth_hero_anywhere(inputs)
});